<template>
  <b-navbar>
    <template #brand>
      <b-navbar-item tag="router-link"
                     to="/"
                     class="no-hover">
        <img src="../assets/viking-logo-white-cropped.svg" />
      </b-navbar-item>
    </template>

    <template #start>
      <b-navbar-item tag="router-link"
                     v-if="isAdmin"
                     :to="{path: '/dashboard'}">Dashboard</b-navbar-item>

      <b-navbar-item tag="router-link"
                     :to="{path: '/calendar'}">Min kalender</b-navbar-item>

      <b-navbar-item tag="router-link"
                     :to="{path: '/schedule'}"
                     v-if="show">Kalender</b-navbar-item>

      <b-navbar-item tag="router-link"
                     :to="{path: '/icalendar'}"
                     v-if="show && icalendarKey">Abonner på arbejdskalender</b-navbar-item>

      <b-navbar-item tag="router-link"
                     :to="{name: 'Reports'}"
                     v-if="show">Rapporter</b-navbar-item>

      <b-navbar-item tag="router-link"
                     v-if="isAdmin"
                     :to="{path: '/configuration'}">Opsætning</b-navbar-item>

      <b-navbar-item tag="router-link"      
                     v-if="isAdmin === false && show"               
                     :to="{path: '/configuration-user'}">Opsætning</b-navbar-item>
    </template>
    <template #end>

      <b-navbar-item tag="a"
                     @click="signOutOidc">
        Log ud <span v-if="currentUser && currentUser.number"> ({{currentUser.number}})</span>
      </b-navbar-item>

      <b-navbar-item class="no-hover">
        <user-badge></user-badge>
      </b-navbar-item>
    </template>
  </b-navbar>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import UserBadge from "./UserBadge.vue";

export default {
  name: "app-header",
  components: { UserBadge },
  data() {
    return {
      windowHeight: window.innerHeight,
      windowWidth: window.innerWidth,
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', this.onResize);
    })
  },
  beforeDestroy() { 
      window.removeEventListener('resize', this.onResize); 
  },
  computed: {
    ...mapGetters("oidcStore", ["oidcIsAuthenticated"]),
    ...mapGetters(["isAdmin", "currentUser", "icalendarKey"]),
    show() {
      return this.windowWidth >  900;
    }
  },
  methods: {
    ...mapActions("oidcStore", ["signOutOidc"]),
    onResize() {
      this.windowHeight = window.innerHeight;
      this.windowWidth = window.innerWidth;
    },
    generateUrl() {
      return "https://localhost:5001/calendar/webICalendar?key=" + this.icalendarKey;
    }
  },
};
</script>

<style scoped lang="scss">
.no-hover {
  background: none !important;
  background-color: none !important;
}

.navbar-item {
  color: $navbar-item-color;

  &:focus {
    background: none;
  }

  &.is-active {
    color: $navbar-tab-active-color;
  }
}

@media screen and (max-width: $desktop) {
  .navbar-item {
    &:hover,
    &.is-active {
      color: #5e8cc0;
      background-color: whitesmoke;
    }
  }
}
</style>
